module.exports = __webpack_public_path__ + "static/media/wizard-dev.c64caf87.png";